import React, { useState, useEffect } from "react";
import { Link, useParams } from "react-router-dom";
import apiClient from "../../../AppClient";
import { Container, Table, Alert, Spinner } from "react-bootstrap";
import { CURRENCY } from "../../../constants/Constants";

const PurchaseView = () => {
  const { id } = useParams(); // Get the purchase ID from the URL
  const [transaction, setTransaction] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  // Fetch purchase transaction details
  const fetchTransaction = async () => {
    setLoading(true);
    try {
      const response = await apiClient.get(`/transactions/purchases/${id}/`);
      setTransaction(response.data);
      setError(null);
    } catch (error) {
      setError(error.response?.data?.detail || "Failed to fetch transaction details.");
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchTransaction();
  }, [id]);

  if (loading) {
    return (
      <Container className="text-center mt-5">
        <Spinner animation="border" role="status" variant="primary">
          <span className="visually-hidden">Loading...</span>
        </Spinner>
      </Container>
    );
  }

  if (error) {
    return (
      <Container className="mt-5">
        <Alert variant="danger">{error}</Alert>
      </Container>
    );
  }

  if (!transaction) {
    return (
      <Container className="mt-5">
        <Alert variant="warning">لا توجد بيانات لعرضها.</Alert>
      </Container>
    );
  }

  return (
    <Container style={{ direction: "rtl", textAlign: "right", padding: "20px", fontFamily: "'Segoe UI', Tahoma, Geneva, Verdana, sans-serif" }}>
      <h1 style={{ color: "#1D4D2C", marginBottom: "20px" }}>تفاصيل فاتورة الشراء</h1>

      {/* Supplier Details */}
      <Table striped bordered hover responsive className="mb-4">
        <thead>
          <tr>
            <th colSpan="2" className="text-center bg-success text-white">
              معلومات المورد
            </th>
          </tr>
        </thead>
        <tbody>
          <tr>
            <td><strong>اسم المورد:</strong></td>
            <td><Link to={`/suppliers/${transaction?.supplier?.id}`}>{transaction.supplier?.name}</Link></td>
          </tr>
          <tr>
            <td><strong>رقم الهاتف:</strong></td>
            <td>{transaction?.supplier?.phone}</td>
          </tr>
          <tr>
            <td><strong>تاريخ آخر طلب:</strong></td>
            <td>{transaction?.supplier?.dateoflastorder}</td>
          </tr>
          <tr>
            <td><strong>إجمالي المشتريات:</strong></td>
            <td>{transaction?.supplier?.total_purshases || "0.00"} {CURRENCY} </td>
          </tr>
          <tr>
            <td><strong>المبلغ المتبقي:</strong></td>
            <td>{transaction?.supplier?.remaining_balance} {CURRENCY}</td>
          </tr>
        </tbody>
      </Table>

      {/* Purchase Details */}
      <Table striped bordered hover responsive className="mb-4">
        <thead>
          <tr>
            <th colSpan="2" className="text-center bg-success text-white">
              معلومات الفاتورة
            </th>
          </tr>
        </thead>
        <tbody>
          <tr>
            <td><strong>رقم الفاتورة:</strong></td>
            <td>{transaction.invoice_number}</td>
          </tr>
          <tr>
            <td><strong>تاريخ الفاتورة:</strong></td>
            <td>{transaction.invoice_date}</td>
          </tr>
          <tr>
            <td><strong>وقت الفاتورة:</strong></td>
            <td>{transaction.invoice_time}</td>
          </tr>
          <tr>
            <td><strong>طريقة الدفع:</strong></td>
            <td>{transaction.payment_method}</td>
          </tr>
          <tr>
            <td><strong>عدد الأقساط:</strong></td>
            <td>{transaction.number_of_installments}</td>
          </tr>
          <tr>
            <td><strong>قيمة الخصم:</strong></td>
            <td>{transaction.discount_value} {CURRENCY}</td>
          </tr>
          <tr>
            <td><strong>اسم مستخدم الخصم:</strong></td>
            <td>{transaction.discount_user_name}</td>
          </tr>
          <tr>
            <td><strong>إجمالي الفاتورة:</strong></td>
            <td>{transaction.total_price} {CURRENCY}</td>
          </tr>
        </tbody>
      </Table>

      {/* Purchase Items */}
      <Table striped bordered hover responsive>
        <thead>
          <tr>
            <th colSpan="6" className="text-center bg-success text-white">
              العناصر المشتراة
            </th>
          </tr>
          <tr>
            <th>#</th>
            <th>اسم المنتج</th>
            <th>الكمية</th>
            <th>سعر الشراء</th>
            <th>سعر البيع النقدي</th>
            <th>إجمالي السعر</th>
          </tr>
        </thead>
        <tbody>
          {transaction.purchase_items.map((item, index) => (
            <tr key={item.id}>
              <td>{index + 1}</td>
              <td>{item.product?.name}</td>
              <td>{item.quantity}</td>
              <td>{item.purchase_price} {CURRENCY}</td>
              <td>{item.sale_price} {CURRENCY}</td>
              <td>{item.total_price} {CURRENCY}</td>
            </tr>
          ))}
        </tbody>
      </Table>
    </Container>
  );
};

export default PurchaseView;